import Swal from 'sweetalert2'

export default {
    name: 'Signin',
    components: {
        Swal
    },
    data () {
        return {
            email: '',
            password: '',
            error: ''
        }
    },
    updated () {
        this.checkSignedIn()
    },
    methods: {
        signin () {
            this.$http.plain.post('/signin', { email: this.email, password: this.password })
                .then(response => this.signinSuccessful(response))
                .catch(error => this.signinFailed(error))
            this.$gtag.event('sign-in-click', {
                'event_category': 'authentication',
                'event_label': 'Sign In'
                })
        },
        signinSuccessful (response) {
            if (!response.data.csrf) {
                this.signinFailed(response)
                return
            }
            localStorage.csrf = response.data.csrf
            localStorage.signedIn = true
            this.error = ''
            this.$router.replace('/home')
        },
        signinFailed (error) {
            this.error = (error.response && error.response.data && error.response.data.error) || ''
            delete localStorage.csrf
            delete localStorage.signedIn
        },
        checkSignedIn () {
            if (localStorage.signedIn) {
                this.$router.replace('/home')
            }
        },
        forgotPassword() {
            Swal.fire({
                title: 'Emailadres',
                input: 'email',
                confirmButtonText: 'Vraag wachtwoord aan',
                showCancelButton: true
                }).then((result) => {
                if (result.value) {
                    this.postNewPassword(result.value)
                }
              })
            this.$gtag.event('forgot-password-click', {
            'event_category': 'authentication',
            'event_label': 'Forgot Password'
            })
        },
        postNewPassword(email) {
            this.$http.plain.post('/new-password', { email: email })
                .then(response => console.log(response))
                .catch(error => console.log(error))
        }
    },
    created() {
        this.checkSignedIn()
        this.$gtag.screenview({
            app_name: 'Retailers',
            screen_name: 'Sign in',
        })
    }
}